import { ReactNode, useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface HoverTooltipProps {
  content: string;
  children: ReactNode;
  // Keeps the tooltip shut, e.g. while the wrapped control's own menu is
  // open: both open below it, so the tooltip would cover the menu.
  suppressed?: boolean;
}

// The trigger is a wrapping div, not the child itself: a disabled Button is
// pointer-events-none and would never open it. Opens below, because above it
// covers the tab bar and swallows tab clicks.
export const HoverTooltip = ({
  content,
  children,
  suppressed = false,
}: HoverTooltipProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      open={open && !suppressed}
      onOpenChange={(next) => setOpen(next && !suppressed)}
    >
      <TooltipTrigger asChild>
        <div className="w-fit">{children}</div>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs">
        {content}
      </TooltipContent>
    </Tooltip>
  );
};
